module.exports = "/images/Government projects.jpg";